import FormDialog from '../Modal/modal';
import PropTypes from 'prop-types';
import alertIcon from '../../Assets/images/svg/alert_icon.svg';
import './formDialogContent.scss';

const FormDialogContent = ({
  open,
  button1,
  button2,
  button1Action,
  button2Action,
  submitButtonId,
  cancelButtonId,
  title,
}) => {
  return (
    <FormDialog
      open={open}
      title={title?.TITLE_TEXT}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="role-dialog-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img alt="Alert Icon" className="icon-image" src={alertIcon} />
          </div>
          <div className="dialog-message-text">{title?.MESSAGE_TEXT}</div>
        </div>
      }
      button1={button1}
      cancelButtonId={cancelButtonId}
      button2={button2}
      submitButtonId={submitButtonId}
      button2Action={button2Action}
      button1Action={button1Action}
    />
  );
};


export default FormDialogContent;

FormDialogContent.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.shape({
    TITLE_TEXT: PropTypes.string.isRequired,
    MESSAGE_TEXT: PropTypes.string.isRequired,
  }).isRequired,
  cancelButtonId: PropTypes.string.isRequired,
  submitButtonId: PropTypes.string.isRequired,
  button1: PropTypes.string.isRequired,
  button2: PropTypes.string.isRequired,
  button1Action: PropTypes.func.isRequired,
  button2Action: PropTypes.func.isRequired,
};
